<script>
import KanboardFrame from './components/KanboardFrame.vue';
import KanboardAPI from 'dashboard/api/kanboard';

export default {
  name: 'KanbanView',
  components: {
    KanboardFrame,
  },
  data() {
    return {
      kanboardUrl: '',
      isLoading: true,
      error: null,
    };
  },
  async created() {
    await this.initializeKanboard();
  },
  methods: {
    async initializeKanboard() {
      try {
        this.isLoading = true;
        this.error = null;

        const response = await KanboardAPI.getAutoLoginUrl();
        this.kanboardUrl = response.data.url;

        this.isLoading = false;
      } catch (error) {
        this.error = error.message || 'Erro ao inicializar Kanboard';
        this.isLoading = false;
      }
    },

    async retryLogin() {
      await this.initializeKanboard();
    },

    refreshKanboard() {
      if (this.$refs.kanboardFrame) {
        this.$refs.kanboardFrame.reload();
      }
    },

    onKanboardError(error) {
      this.error = error;
    },
  },
};
</script>

<template>
  <div class="kanban-container">
    <div v-if="isLoading" class="loading-container">
      <div class="loading-content">
        <div class="spinner" />
        <p>{{ $t('KANBAN.CONECTING') }}</p>
        <small>{{ $t('KANBAN.INPROGRESS') }}</small>
      </div>
    </div>

    <div v-if="error" class="error-container">
      <div class="error-content">
        <div class="error-icon">{{ $t('KANBAN.ICON') }}</div>
        <h3>{{ $t('KANBAN.ERROR') }}</h3>
        <p>{{ error }}</p>
        <button class="btn btn-primary" @click="retryLogin">
          {{ $t('KANBAN.RETRY') }}
        </button>
      </div>
    </div>

    <div v-if="!isLoading && !error" class="kanban-content">
      <KanboardFrame
        ref="kanboardFrame"
        :url="kanboardUrl"
        @loaded="onKanboardLoaded"
        @error="onKanboardError"
      />
    </div>
  </div>
</template>

<style scoped>
.kanban-container {
  height: auto;
  width: 100%;
  display: flex;
  flex-direction: column;
  background: #f8f9fa;
  padding: 1rem 1.5rem;
  border-radius: 10px;
}

.kanban-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.5rem;
  background: white;
  border-bottom: 1px solid #e9ecef;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.header-left {
  display: flex;
  align-items: center;
}

.page-title {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 600;
  color: #2d3748;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.account-info {
  font-size: 0.875rem;
  color: #718096;
  background: #edf2f7;
  padding: 0.25rem 0.75rem;
  border-radius: 0.375rem;
}

.btn {
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-primary {
  background: #3182ce;
  color: white;
}

.btn-primary:hover {
  background: #2c5aa0;
}

.btn-secondary {
  background: #e2e8f0;
  color: #4a5568;
}

.btn-secondary:hover {
  background: #cbd5e0;
}

.kanban-content {
  flex: 1;
  overflow: hidden;
}

.loading-container,
.error-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.loading-content,
.error-content {
  text-align: center;
  padding: 2rem;
}

.spinner {
  width: 3rem;
  height: 3rem;
  border: 0.25rem solid #e9ecef;
  border-top: 0.25rem solid #3182ce;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 1rem;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.error-icon {
  font-size: 3rem;
  margin-bottom: 1rem;
}

.error-content h3 {
  color: #e53e3e;
  margin-bottom: 0.5rem;
}

.error-content p {
  color: #718096;
  margin-bottom: 1.5rem;
}
</style>
